export default "__VITE_ASSET__CruZuLuY__"